import { defu } from 'defu'
import type { UseFetchOptions } from 'nuxt/app'

class FetchFactory<T> {
    async call(
        url: MaybeRefOrGetter<string>,
        options: UseFetchOptions<T> = {},
  ): Promise<T> {
        const config = useRuntimeConfig()

        const clientCookies = useRequestHeaders(['cookie'])
        const locale = useCookie('i18n_redirected')

        const headers: any = {
            Accept: 'application/json',
            Origin: config.public.jobSeekerUrl,
            'Accept-Language': locale.value,
            ...clientCookies,
    }

        if (options.method !== 'GET' && !url.includes('/api/media')) {
            await $fetch('/api/sanctum/csrf-cookie', {
                method: 'GET',
                headers
            })
        }

        const XSRF_TOKEN = useCookie('XSRF-TOKEN')

        if (XSRF_TOKEN.value) {
            headers['X-Xsrf-Token'] = XSRF_TOKEN.value
        }

        const defaults: UseFetchOptions<T> = {
            key: toValue(url),
            headers
        }

        const params = defu(options, defaults)

        return await $fetch<T>(url, params)
    }
}

export default FetchFactory
